import type { APIManufacturerAliasReference } from '@visorpro/client'
import type { MRT_Row } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { useManufacturerById } from '../../../../stores/manufacturers-store'
import type { Stores } from '../../../../util/store'
import type { MouseEvent } from 'react'
import { ManufacturerAliasModalState } from './types'

export interface RegisteredManufacturerCellProps {
    row: MRT_Row<APIManufacturerAliasReference>
    stores: Stores
    onOpen(e: MouseEvent, state: ManufacturerAliasModalState): void
}

export const RegisteredManufacturerCell =
    observer<RegisteredManufacturerCellProps>(({ row, stores, onOpen }) => {
        const manufacturerId = row.original.product_manufacturer_id
        const manufacturer = useManufacturerById(
            manufacturerId ?? undefined,
            stores,
        )

        const state: ManufacturerAliasModalState = {
            input_manufacturer: row.original.input_manufacturer,
            alias_id: row.original.alias_id,
            initial_manufacturer_id: manufacturer?.id,
        }

        if (manufacturer) {
            return (
                <span
                    onClick={(e) => {
                        onOpen(e, state)
                    }}
                    style={{
                        borderRadius: '1rem',
                        padding: '0px 6px',
                        backgroundColor: 'var(--selection-color-opaque)',
                        cursor: 'pointer',
                    }}>
                    {manufacturer.name}
                </span>
            )
        }

        return (
            <div>
                <button
                    onClick={(e) => {
                        onOpen(e, state)
                    }}
                    style={{
                        position: 'relative',
                        padding: 0,
                        background: 'none',
                        outline: 'none',
                        border: 'none',
                        color: 'var(--purple-color)',
                        cursor: 'pointer',
                    }}>
                    search
                </button>
            </div>
        )
    })

